

































import { Vue, Prop, Component } from 'vue-property-decorator';
import echarts from 'echarts';
import { namespace } from 'vuex-class';
import { AcgnFormTitle, AcgnFormContent, AcgnTargetEdit } from '@/components';
import { statisticChartColors } from '@/constants/type-helper';
import { openUrl } from '@/util';
import { TargeMixin } from '@/mixins';

const StatisticNorAction = namespace('desk/statisticNor').Action;
const StatisticAction = namespace('desk/statistic').Action;
const CommGetter = namespace('desk/comm').Getter;

interface PopTargetData { // 弹窗
  visible: boolean; // 是否显示
  data: any; // 弹窗交互数据
}

@Component({
  components: {
    AcgnFormTitle,
    AcgnFormContent,
    AcgnTargetEdit
  },
  mixins: [TargeMixin]
})

/**
 * 创作方图表-目标进度
 */
export default class AcgnStatisticStaffChartD extends Vue {
  public name: string = 'AcgnStatisticStaffChartD';

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 成员id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码
  @Prop({ default: '目标进度' }) public title: string; // 标题
  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  @StatisticNorAction private getTargetCycleDetail: any;
  @StatisticAction private getTargetCycleAdminDetail: any;
  @CommGetter private attributeData: any; // 公共类型

  private chartData: any = [];
  private chartInstance: any; // 表格实例
  private colors: any = statisticChartColors;

  private apiKey: any = {
    1: 'getTargetCycleDetail',
    2: 'getTargetCycleAdminDetail'
  };

  private get showTitle() {
    if (this.chartData.length === 0) {
      return '目标周期数据未生成';
    }
    const { time_slot, target_type, finished_num, target_num } = this.chartData[0];
    return `${time_slot} ${this.getShowName(target_type)} ${finished_num}/${target_num}`;
  }

  private getShowName(target_type: number) {
    if (this.userId) {
      return (this as any).userTargetName(target_type);
    }
    return (this as any).comicTargetName(target_type);
  }

  private async created() {
    this.chartData = (await (this as any)[this.apiKey[this.type]](this.getSearchOptions())).result;
    this.setData(this.chartData);
  }

  private getSearchOptions() {
    return { project_id: this.comicId, user_id: this.userId };
  }

  private mounted() {
    this.chartInstance = echarts.init(document.getElementById('staff-chartd'), 'light');
  }

  // 默认展示环节数
  private setData(result: any, type = 'target_num') {
    const source: any = [['product', '目标数', '完成数'], [], [], [], [], [], [], [], [], [], [], [], []];
    const series: any = [
      { type: 'bar', color: this.colors[0], barWidth: 20 },
      { type: 'bar', color: this.colors[4], barWidth: 20 }
    ];
    result.map((itemData: any, dataIndex: number) => {
      const index = dataIndex + 1;
      source[index].push(itemData.time_slot);
      source[index].push(itemData.target_num);
      source[index].push(itemData.finished_num);
    });

    this.chartInstance.setOption(
      {
        legend: {},
        tooltip: {},
        dataset: {
          source
        },
        xAxis: { type: 'category' },
        yAxis: {},
        grid: {
          left: 30
        },
        series
      }
    );
  }

  private exportExcel() {
    if (this.type === 1) {
      openUrl('/api/v1/workbench/targetcycle?export=1', this.getSearchOptions());
    } else {
      openUrl('/api/v1/workbench/gettargetcycleofadmin?export=1', this.getSearchOptions());
    }
  }

  private editTarget() {
    if (this.userId) {
      this.$router.push({ name: 'desk-staffList', params: { project_id: this.comicId + '' } });
      return;
    }
    this.$router.push({ name: 'desk-comicAuthEdit', params: { id: this.comicId + '' } });
  }
}
